import { DispatcherEvent } from '@carvana/merch-native';
import { useEffectOnce } from '@carvana/merch-react-hooks';
import { useIsNative } from '~/context/common/DeviceContext';
import { navPerformanceNow } from '~/utilities/navigationTiming';
import sendMessageToNative from './sendMessageToNative';

export default function usePageReadyDispatcher(
  shouldSend: boolean,
  hasValidSoftPull: boolean
) {
  const isNative = useIsNative();

  const shouldSendPageReady = shouldSend && isNative;

  useEffectOnce(
    () => {
      sendMessageToNative(DispatcherEvent.PageReady, {
        hasValidSoftPull,
        navigationToNowMs: navPerformanceNow()
      });
    },
    [hasValidSoftPull],
    shouldSendPageReady
  );
}
